import { css } from 'aphrodite';
import { styleSheet } from '../styles';

export function NoActionStepConfig() {
	return <div className={css(styleSheet.fieldLabel)}>Take no action.</div>;
}
